export class TimeoutError extends Error {
    constructor(readonly timeoutMs: number) {
        super(`Timed out after ${timeoutMs}ms`);
        this.name = "TimeoutError";
    }
}

export function withTimeout<T>(promise: Promise<T>, timeoutMs: number) {
    let timeoutId: ReturnType<typeof setTimeout> | undefined;
    const timeout = new Promise<never>((_, reject) => {
        timeoutId = setTimeout(
            () => reject(new TimeoutError(timeoutMs)),
            timeoutMs,
        );
    });
    return Promise.race([promise, timeout]).finally(() =>
        clearTimeout(timeoutId),
    );
}
